import { Injectable } from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { DatePreset } from '@shared/constants/date-presets.enum';
import moment, { Moment } from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DatePresetsService {
  constructor() {}

  /**
   * Get the date range for a given date preset
   * @param preset - The date preset to get the date range for
   * @returns The date range for the given date preset
   */
  static getDateRange(preset: DatePreset): DateRange<Moment> {
    if (preset === DatePreset.closedWeek) {
      // Get the most recent Saturday (0 = Sunday, 6 = Saturday in moment)
      const lastSaturday = moment().day(moment().day() <= 6 ? -1 : 6);
      // Get the Sunday before the last Saturday (6 days before)
      const lastSunday = moment(lastSaturday).subtract(6, 'days');

      return new DateRange<Moment>(lastSunday, lastSaturday);
    } else if (preset === DatePreset.closedMonth) {
      const lastMonth = moment().subtract(1, 'month');
      const firstDayOfMonth = moment(lastMonth).startOf('month');
      const lastDayOfMonth = moment(lastMonth).endOf('month');

      return new DateRange<Moment>(firstDayOfMonth, lastDayOfMonth);
    } else if (preset === DatePreset.closedQuarter) {
      const lastQuarter = moment().subtract(1, 'quarter');
      const firstDayOfQuarter = moment(lastQuarter).startOf('quarter');
      const lastDayOfQuarter = moment(lastQuarter).endOf('quarter');

      return new DateRange<Moment>(firstDayOfQuarter, lastDayOfQuarter);
    } else if (preset === DatePreset.closedThreeMonths) {
      const threeMonthsAgo = moment().subtract(3, 'month');
      const oneMonthAgo = moment().subtract(1, 'month');
      const firstDayOfThreeMonths = moment(threeMonthsAgo).startOf('month');
      const lastDayOfOneMonth = moment(oneMonthAgo).endOf('month');

      return new DateRange<Moment>(firstDayOfThreeMonths, lastDayOfOneMonth);
    }
  }
}
